export default "https://cdn-static.gokick.com/assets/b944ecdade3ab4b24738bd1fcec1eea00d00fb75/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";